<div
    class="rating-star-container"
    [ngClass]="{
        'flex align-items-center': inline || center,
        'justify-center': center,
        'ratings-star-single': starDisplay === 'single'
    }">
    <div class="rating-stars flex align-items-start">
        <div class="ratings-star--rating" [ngClass]="{ 'sr-only': !displayRatingAmount }">
            <div *ngIf="starDisplay === 'single'" class="margin-right-small">
                <lib-rating-star [size]="20" display="fill" />
            </div>
            <p
                class="rating-stars-total-rating"
                [ngClass]="{
                    'rating-stars-total-rating--large': ratingTextSize === 'large'
                }">
                @if (rating > 0) {
                    {{ rating | number: '1.0-1' }}
                    <span class="sr-only">rating</span>
                } @else {
                    -
                }
            </p>
        </div>
        <ng-content *ngIf="starDisplay === 'rating'">
            <div *ngFor="let index of [1, 2, 3, 4, 5]" class="rating-star">
                <lib-rating-star
                    [size]="starSize ? starSize : 16"
                    [display]="
                        rating >= index - 0.5 && rating < index
                            ? 'half'
                            : rating >= index - 0.5 && rating >= index - 1
                              ? 'fill'
                              : 'empty'
                    " />
            </div>
        </ng-content>
    </div>
    <p *ngIf="totalRatings && displayTotalRatingsCount" class="number-of-ratings-text">
        <span *ngIf="totalRatingsWithBrackets">&#40;</span>
        <span>{{ totalRatings }}</span>
        <span *ngIf="totalRatings === 1">&nbsp;review</span>
        <span *ngIf="totalRatings !== 1">&nbsp;reviews</span>
        <span *ngIf="totalRatingsWithBrackets">&#41;</span>
    </p>
</div>
